import { Injectable } from "@angular/core";
import { UserService } from "./user.service";

@Injectable({
  providedIn: "root",
})
export class PermissionsService {
  isRequiredPersonalData: boolean = true;
  isRequiredPersonalDataOpen: boolean = false;
  public permissionsState: { [key: string]: boolean };

  constructor(private userService: UserService) {
    this.isRequiredPersonalData =
      this.userService.isRequiredPersonalData.getValue();
    this.userService.isRequiredPersonalData.subscribe((b) => {
      // console.log("isRequiredPersonalData.subscribe", b);
      this.isRequiredPersonalData = b;
    });
    this.isRequiredPersonalDataOpen =
      this.userService.isRequiredPersonalDataOpen.getValue();
    this.userService.isRequiredPersonalDataOpen.subscribe((b) => {
      // console.log("isRequiredPersonalData.subscribe", b);
      this.isRequiredPersonalData = b;
    });
  }

  getPermissions() {
    // if(this.isRequiredPersonalData) return {}
    return this.permissionsState;
  }

  setPermissions(value) {
    this.permissionsState = value;
  }

  hasNav(key: string): boolean {
    if (this.isRequiredPersonalData) return false;
    if (!this.permissionsState.hasOwnProperty(key)) {
      return false;
    }

    return this.permissionsState[key];
  }

  has(key: string): boolean {
    if (this.isRequiredPersonalDataOpen) return false;
    if (!this.permissionsState.hasOwnProperty(key)) {
      return false;
    }

    return this.permissionsState[key];
  }
}
